import React from 'react';
import { trackCheckoutClick } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  children,
  href = '#precios',
  variant = 'primary',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2 rounded-full font-display font-extrabold uppercase tracking-wide transition-transform duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy hover:-translate-y-0.5 active:translate-y-0';
  const variants: Record<string, string> = {
    primary: 'bg-gold text-navy-deep shadow-pop hover:bg-gold-light border-b-4 border-gold-dark',
    secondary: 'bg-white text-navy shadow-card border-b-4 border-celeste-dark hover:bg-celeste-light'
  };
  const sizes: Record<string, string> = {
    md: 'px-6 py-3 text-sm',
    lg: 'px-7 py-4 text-base sm:px-10 sm:text-lg'
  };
  return <a href={href} onClick={() => trackCheckoutClick(href)} className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-62" data-mp="35zin6gfh28r5">
      {children}
    </a>;
}